<script setup lang="ts">
import { computed } from 'vue'
import { useTaskListStore } from '../stores/tasking-store'

const props = defineProps<{
  entityType: 'spv' | 'fund'
  billingSettled?: boolean
  billingRoute?: object
}>()

const store = useTaskListStore()
const entityLabel = computed(() => (props.entityType === 'fund' ? 'Fund' : 'SPV'))
const visible = computed(() => store.taskList?.is_visible && !props.billingSettled)
</script>

<template>
  <div
    v-if="visible"
    class="flex items-center justify-between rounded-xl border border-orange-300 bg-orange-100 px-5 py-4"
  >
    <div class="flex items-center gap-4">
      <div class="flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-orange-200 bg-white">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-5 w-5 text-amber-600"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
          <line x1="12" y1="9" x2="12" y2="13" />
          <line x1="12" y1="17" x2="12.01" y2="17" />
        </svg>
      </div>
      <div>
        <h3 class="text-sm font-bold text-gray-900">Complete Payment</h3>
        <p class="mt-0.5 text-sm text-gray-500">
          You have 30 days to complete your payment before this {{ entityLabel }} is locked.
        </p>
      </div>
    </div>
    <RouterLink v-if="billingRoute" :to="billingRoute">
      <button
        class="ml-4 rounded-md bg-orange-600 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-orange-700 active:translate-y-px"
      >
        Pay Now
      </button>
    </RouterLink>
  </div>
</template>
